<template>
  <modal-frame
    :isVisible="props.isVisible"
    :width="'90%'"
    :max-width="'700px'"
    :height="'80%'"
    :max-height="'650px'"
    :isOverlay="false"
    customClass="liq-modal"
    @closeDialogHandler="closeHandler(0)"
  >
    <div class="modal_title">
      <h4 @click="isShowCoinList = !isShowCoinList">
        {{ ticker }}USDT <span class="perp">Perp</span
        ><img
          :class="['ab drop-arrow', { active: isShowCoinList }]"
          src="@/assets/images/components/trading/icon_select_arrow.png"
          alt="arrow-down"
        />
      </h4>
      <button class="close-btn" @click="closeHandler(0)">×</button>
      <div class="ab dropdown coin-list-dropdown" v-if="isShowCoinList">
        <input
          type="text"
          :placeholder="$t('trading.liqprice.search')"
          v-model="searchStr"
          @input="searchCoinList"
        />
        <ul class="">
          <li
            v-for="item in coinList"
            :key="item"
            @click="changeSelectCoin(item)"
            :class="{ active: item === `${ticker}USDT` }"
          >
            <img class="coin-img" :src="getCoinIcon(item)" />
            <p>{{ item }}</p>
            <span class="perp">Perp</span>
          </li>
        </ul>
      </div>
      <div class="modal-tab">
        <p>{{ tabItems[0].value }}</p>
        <!-- <Tab :tabItems="tabItems" @tabSelectHandler="tabSelectHandler" /> -->
      </div>
    </div>
    <div class="modal_body">
      <div class="cal-left">
        <div class="mg-type pr" @click="isShowMarginType = !isShowMarginType">
          <p>
            {{
              selectInfo.marginType === 0
                ? $t("trading.table.isolated")
                : $t("trading.table.cross")
            }}
          </p>
          <img
            :class="['ab drop-arrow', { active: isShowMarginType }]"
            src="@/assets/images/components/trading/icon_select_arrow.png"
            alt="arrow-down"
          />
        </div>
        <div class="ab dropdown size-dropdown" v-if="isShowMarginType">
          <ul>
            <li
              v-for="item in marginItems"
              :key="'margin' + item.key"
              @click="selectMarginType(item.key)"
              :class="{ active: item.key === selectInfo.marginType }"
            >
              {{ item.value }}
            </li>
          </ul>
        </div>
        <div class="position-btn">
          <div class="tab-wrapper">
            <button
              :class="['tab long', { active: selectInfo.position === 0 }]"
              @click="selectInfo.position = 0"
            >
              {{ $t("trading.table.long") }}
            </button>
            <div v-if="selectInfo.position === 0" class="arrow right green"></div>
          </div>
          <div class="tab-wrapper">
            <button
              :class="['tab short', { active: selectInfo.position === 1 }]"
              @click="selectInfo.position = 1"
            >
              {{ $t("trading.table.short") }}
            </button>
            <div v-if="selectInfo.position === 1" class="arrow left red"></div>
          </div>
        </div>
        <div class="leverage-container">
          <div class="control">
            <button @click="decrease">–</button>
            <span>{{ selectInfo.leverage }}x</span>
            <button @click="increase">+</button>
          </div>

          <div class="slider" @click="handleClick">
            <div
              v-for="point in points"
              :key="point"
              class="tick"
              :style="{ left: getLeftPercent(point) + '%' }"
            ></div>
            <div class="track" :style="{ width: position + '%' }"></div>
            <div
              class="marker"
              @mousedown="handleMouseDown"
              :style="{ left: position + '%' }"
            ></div>
          </div>

          <div class="scale">
            <span
              v-for="point in points"
              :key="point"
              :style="{ left: getLeftPercent(point) + '%' }"
              >{{ point }}x</span
            >
          </div>
        </div>
        <div class="cal-info">
          <p>{{ $t("trading.table.entryPrice") }}</p>
          <input
            type="text"
            v-model="selectInfo.entryPrice"
            @input="priceInputHandler($event, 'entry', true)"
          />
          <p class="ab">USDT</p>
        </div>
        <div class="cal-info">
          <p v-html="$t('trading.liqprice.quantity')"></p>
          <input
            type="text"
            v-model="selectInfo.quantity"
            @input="priceInputHandler($event, 'quantity', true)"
          />
          <p class="ab">USDT</p>
        </div>
        <div class="cal-info" v-if="selectInfo.marginType === 1">
          <p style="line-height: 13px">{{ $t("trading.liqprice.balance") }}</p>
          <input
            type="text"
            v-model="selectInfo.balance"
            @input="priceInputHandler($event, 'balance', false)"
          />
          <p class="ab">USDT</p>
        </div>
        <div class="modal_btn">
          <button @click="calculateHandler" class="btn-primary">
            {{ $t("trading.liqprice.calculate") }}
          </button>
        </div>
      </div>
      <div class="cal-right">
        <div class="res">
          <p>{{ $t("trading.liqprice.results") }}</p>
          <div class="res-info">
            <span>{{ $t("trading.liqprice.liqPrice") }}</span>
            <p>{{ formatNumberWithComma(liqPrice) }}USDT</p>
          </div>
        </div>
        <div class="caution">
          <p>* {{ $t("trading.liqprice.caution01") }}</p>
          <p>* {{ $t("trading.liqprice.caution02") }}</p>
        </div>
      </div>
    </div>
    <div class="main-caution">* {{ $t("trading.liqprice.caution03") }}</div>
  </modal-frame>
  <ModalAlert
    :isVisible="alertDialog.isVisible"
    :content="alertDialog.content"
    @closeDialogHandler="closeAlertDialogHandler"
    :is-btn="true"
  />
</template>

<script setup>
import {
  defineProps,
  defineEmits,
  ref,
  onMounted,
  onBeforeUnmount,
  computed,
  watch,
} from "vue";
import ModalAlert from "@/components/common/modal/ModalAlert.vue";
import ModalFrame from "@/components/common/modal/ModalFrame.vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import Tab from "@/components/common/tab/Tab.vue";
import { inputNumCheck, formatNumberWithComma } from "@/utils/order";
import { selectedSymbolData } from "@/utils/symbol";
const store = useStore();
const emit = defineEmits(["closeDialogHandler"]);
const props = defineProps({
  isVisible: Boolean,
  width: String,
  selectTicker: String,
});
const { t } = useI18n();
const marginItems = [
  {
    key: 1,
    value: t("trading.table.cross"),
  },
  {
    key: 0,
    value: t("trading.table.isolated"),
  },
];
const points = [1, 5, 10, 15, 20];
const pointLength = 20;
const pointLengthLeft = 19;
const tabItems = ref([
  {
    key: "liqprice",
    value: t("trading.liqprice.liqPrice"),
    isActive: true,
    isBeta: false,
  },
]);
const selectInfo = ref({
  marginType: marginItems[0].key,
  position: 0,
  leverage: 1,
  entryPrice: null,
  quantity: null,
  balance: 0.0,
});
const alertDialog = ref({
  isVisible: false,
  content: "",
});
const position = ref(0);
const dragging = ref(false);
const isShowCoinList = ref(false);
const searchStr = ref("");
const isShowMarginType = ref(false);
const ticker = ref(props.selectTicker);
const coinCombo = ref([]);
const coinList = computed(() => {
  if (searchStr.value !== "") {
    const filterd = coinCombo.value.filter((v) => v.value.includes(searchStr.value));
    return filterd.map(item => item.value + "USDT");
  } else {
    return coinCombo.value.map(item => item.value + "USDT");
  }
});
const reCode = computed(() => store.state.transact.reCode);
const liqPrice = computed(() => store.state.transact.liqPrice);
const getLeftPercent = (val) => ((val - 1) / pointLengthLeft) * 100;

const updatePosition = () => {
  position.value = ((selectInfo.value.leverage - 1) / pointLengthLeft) * 100;
};

const increase = () => {
  if (selectInfo.value.leverage < pointLength) {
    selectInfo.value.leverage++;
    updatePosition();
  }
};

const decrease = () => {
  if (selectInfo.value.leverage > 1) {
    selectInfo.value.leverage--;
    updatePosition();
  }
};

const handleClick = (e) => {
  const rect = e.currentTarget.getBoundingClientRect();
  const clickX = e.clientX - rect.left;
  const percent = (clickX / rect.width) * 100;
  const lev = Math.round((percent / 100) * pointLengthLeft) + 1;
  selectInfo.value.leverage = Math.min(Math.max(lev, 1), pointLength);
  updatePosition();
};

const handleMouseDown = () => {
  dragging.value = true;
};

const handleMouseMove = (e) => {
  if (!dragging.value) return;

  const slider = document.querySelector(".slider");
  const rect = slider.getBoundingClientRect();
  const moveX = e.clientX - rect.left;
  const percent = (moveX / rect.width) * 100;
  const lev = Math.round((percent / 100) * pointLengthLeft) + 1;
  selectInfo.value.leverage = Math.min(Math.max(lev, 1), pointLength);
  updatePosition();
};

const handleMouseUp = () => {
  dragging.value = false;
};

const tabSelectHandler = (payload) => {
  tabItems.value.forEach((t) => {
    t.isActive = t.key === payload;
  });
};

const searchCoinList = () => {
  searchStr.value = searchStr.value.toUpperCase();
};

const handleClickOutside = (e) => {
  const isPopup = e.target.closest(".coin-list-dropdown");
  const isInput = e.target.closest(".modal_title h4");
  if (isShowCoinList.value && !isPopup && !isInput) {
    isShowCoinList.value = false;
  }
  const isSizePopup = e.target.closest(".size-dropdown");
  const isSizeInput = e.target.closest(".mg-type");

  if (isShowMarginType.value && !isSizePopup && !isSizeInput) {
    isShowMarginType.value = false;
  }
};

const getCoinIcon = (coin) => {
  const symbol = coin.slice(0, -4);
  try {
    return require(`@/assets/images/coin_logos/${symbol.toLowerCase()}.png`);
  } catch {
    return require("@/assets/images/coin_logos/default_dark.png");
  }
};

const changeSelectCoin = (coin) => {
  const symbol = coin.slice(0, -4);
  ticker.value = symbol.toUpperCase();
  searchStr.value = ticker.value;
  isShowCoinList.value = false;
};

const selectMarginType = (item) => {
  selectInfo.value.marginType = item;
  isShowMarginType.value = false;
};

const priceInputHandler = (e, type, isPrice) => {
  const symbolData = selectedSymbolData(ticker.value);
  let value = e.target.value;
  let formattedPrice;
  if (Number(value) > 10_000_000_000) {
    formattedPrice = 10_000_000_000;
  } else {
    if (isPrice) {
      formattedPrice = inputNumCheck(value, symbolData?.pricePrecision);
    } else {
      formattedPrice = inputNumCheck(value, 2);
    }
  }
  if (type === "entry") {
    selectInfo.value.entryPrice = formattedPrice;
  } else if (type === "quantity") {
    selectInfo.value.quantity = formattedPrice;
  } else {
    selectInfo.value.balance = formattedPrice;
  }
};

const calculateHandler = async () => {
  if (
    !ticker.value ||
    !selectInfo.value.leverage ||
    !selectInfo.value.entryPrice ||
    parseFloat(selectInfo.value.entryPrice) === 0 ||
    !selectInfo.value.quantity ||
    parseFloat(selectInfo.value.quantity) === 0 ||
    (selectInfo.value.marginType === 1 && !selectInfo.value.balance) ||
    (selectInfo.value.marginType === 1 && parseFloat(selectInfo.value.balance) === 0)
  ) {
    alertDialog.value.isVisible = true;
    alertDialog.value.content = t("trading.liqprice.fieldMsg");
    return;
  }
  let reqInfo = {
    symbol: ticker.value,
    margin_type: selectInfo.value.marginType,
    leverage: selectInfo.value.leverage,
    side: selectInfo.value.position,
    price: selectInfo.value.entryPrice,
    amount: selectInfo.value.quantity,
  };
  if (reqInfo.margin_type === 1) {
    reqInfo.balance = selectInfo.value.balance;
    if (reqInfo.amount / reqInfo.leverage > reqInfo.balance) {
      alertDialog.value.isVisible = true;
      alertDialog.value.content = t(`trading.error.104`);
      return;
    }
  }

  await store.dispatch("transact/getCalculateLiqprice", reqInfo);
  if (reCode.value !== 0) {
    alertDialog.value.isVisible = true;
    alertDialog.value.content = t(`trading.error.${reCode.value}`);
  }
};

const closeHandler = () => {
  emit("closeDialogHandler");
  selectInfo.value = {
    marginType: marginItems[0].key,
    position: 0,
    leverage: 1,
    entryPrice: null,
    quantity: null,
    balance: 0.0,
  };
  updatePosition();
};

const closeAlertDialogHandler = () => {
  alertDialog.value.isVisible = false;
};

onMounted(async () => {
  coinCombo.value = await store.dispatch("getCoinList/getCoinComboList");
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);
  document.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
  window.removeEventListener("mousemove", handleMouseMove);
  window.removeEventListener("mouseup", handleMouseUp);
  document.removeEventListener("click", handleClickOutside);
});
watch(
  () => props.selectTicker,
  (v) => {
    ticker.value = v;
  }
);
watch(
  () => isShowCoinList.value,
  (v) => {
    if (!v) {
      searchStr.value = "";
    }
  }
);
</script>
<style lang="scss" scoped>
@import url("@/assets/scss/components/common/modal.scss");
* {
  font-family: --main-font-Light, "Noto Sans JP", "Noto Sans SC";
}

.label {
  margin-bottom: 6px;
  font-size: 14px;
  color: var(--txt-default-color);
}

.control {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--section-color);
  border: 1px solid #999;
  padding: 6px 12px;
  border-radius: 6px;
  margin-bottom: 20px;
}

.control button {
  background: none;
  color: var(--txt-default-color);
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 4px 12px;
}

.control span {
  flex: 1;
  text-align: center;
  font-weight: bold;
  font-size: 1.5rem;
  /* color: #2b2b2b; */
}

.modal_body {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.cal-left {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mg-type {
  max-width: 160px;
  background-color: var(--section-color);
  border : 1px solid #999;
  padding: 10px;
  border-radius: 5px;

  .ab {
    width: 15px;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.dropdown {
  z-index: 9;
  top: 40px;
  margin-top: 5px;
  /* background-color: var(--txt-gray-color); */
  background-color: var(--section-color);
  border: 1px solid var(--primary-color);
  width: 100%;
  max-width: 160px;
  padding: 10px;
  border-radius: 5px;

  li {
    color: var(--txt-default-color);
    /* color: #3b3b3b; */
    padding: 5px 0;
    font-size: 1.5rem;
  }
}

.position-btn {
  display: flex;
  /* border: 1px solid #ccc; */
  border-radius: 6px;
  overflow: hidden;
  /* overflow: visible; */
}

.tab-wrapper {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.tab {
  flex: 1;
  padding: 8px 16px;
  border: none;
  background: var(--modal-color);
  color: var(--txt-default-color);
  cursor: pointer;
  font-weight: 500;
  position: relative;
  z-index: 1;
}

.long.active {
  background: #2ecc71;
  color: white;
  font-weight: bold;
}

.short.active {
  background: #e74c3c;
  color: white;
  font-weight: bold;
}

.arrow {
  position: absolute;
  top: 0;
  width: 20px;
  height: 100%;
  z-index: 2;
  pointer-events: none;
}

.arrow.right {
  right: -20px;
  clip-path: polygon(0 0, 100% 50%, 0 100%);
}

.arrow.left {
  left: -20px;
  clip-path: polygon(100% 0, 100% 100%, 0 50%);
}

.arrow.green {
  background: #2ecc71;
}

.arrow.red {
  background: #e74c3c;
}

.cal-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--modal-color);
  border : 1px solid #999;
  border-radius: 5px;
  position: relative;
  padding: 0 10px;
  p {
    text-align: center;
  }

  p:nth-of-type(1) {
    color: var(--txt-gray-color);
  }

  input {
    width: 180px;
    padding-right: 45px;
    background-color: transparent;
    border: none;
    text-align: right;
    color: var(--txt-default-color);
  }

  .ab {
    right: 10px;
    color: var(--txt-default-color);
  }
}

.leverage-container {
  margin-bottom: 20px;
}

.modal_btn {
  padding: 0;

  button.disabled {
    /* filter: brightness(1.2); */
  }
}

.cal-right {
  border-radius: 5px;
  border: 1px solid var(--txt-gray-color);
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .res p {
    font-size: 1.8rem;
  }

  .res-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;

    span {
      color: var(--txt-gray-color);
      font-weight: 400;
      font-size: 1.5rem;
    }

    p {
      color: var(--txt-default-color);
      font-size: 1.6rem;
    }
  }

  .caution p {
    margin-top: 10px;
    font-weight: 400;
  }
}

.main-caution {
  padding: 20px;
  font-weight: 400;
  color: var(--txt-default-color);
  font-size: 1.5rem;
}

.modal-tab {
  padding: 10px 20px;

  p {
    margin: 0 auto;
    width: fit-content;
    border-bottom: 2px solid var(--primary-color);
    padding: 0 30px 5px;
  }
}
.perp {
  background-color: var(--primary-color);
  color:#000 !important;
}
.modal_body{
  padding: 0;
}
.modal_title {
  h4 {
    text-align: left;
    padding: 0 20px;
    position: relative;
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 5px;

    .ab {
      right: 0;
      width: 15px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .dropdown {
    top: 30px;
    left: 20px;
    height: 300px;
    width: 100%;
    max-width: 230px;
    overflow: hidden;
    box-shadow: var(--box-shadow);
    margin: 0;

    input {
      width: 100%;
      margin-bottom: 5px;
      padding: 0 10px;
      background-color: var(--bg-color);
      border: 1px solid var(--txt-gray-color);
      color: var(--txt-default-color);
    }

    ul {
      overflow-y: scroll;
      height: calc(100% - 40px);

      li {
        display: flex;
        gap: 5px;
      }
    }
  }
}

.coin-img {
  width: 15px;
}

.dropdown ul li.active {
  position: relative;

  &.active::after {
    content: "";
    position: absolute;
    top: 8px;
    right: 6px;
    width: 6px;
    height: 10px;
    border: solid var(--primary-color);
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
}

.drop-arrow.active {
  transform: translateY(-50%) rotate(180deg) !important;
}

@media screen and (max-width: 768px) {
  .modal_body {
    grid-template-columns: repeat(1, 1fr);
  }
}


</style>
